"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var mobx_1 = require("mobx");
var ProjectTypes_1 = require("../ProjectTypes");
var Collaborator_1 = __importDefault(require("Project/Service/Collaborator"));
var ResourceTypes_1 = require("@CommonFrontendBackend/Resources/ResourceTypes");
var TimeSince_1 = require("@CommonFrontendBackend/Utils/TimeSince");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var ProjectLinkStore_1 = require("./ProjectLinkStore/ProjectLinkStore");
var AngularSyncStore_1 = __importDefault(require("Utils/AngularSyncStore"));
var AutoLinkExpiry_1 = require("@CommonFrontendBackend/Project/AutoLinkExpiry");
var PermissionTypes_1 = require("DataStores/Permissions/PermissionTypes");
var ProjectStore = (function (_super) {
    __extends(ProjectStore, _super);
    function ProjectStore(projectData, projectApiService, pageResourceApiService, _user, projectTelemetry, rootDataStore, genericHost, angularSyncServices) {
        if (angularSyncServices === void 0) { angularSyncServices = { disableSync: true }; }
        var _this = _super.call(this, projectData, angularSyncServices, {
            extractDataFromAngular: extractDataFromAngular,
            skipDiffOnAngularChange: true,
        }) || this;
        _this.projectApiService = projectApiService;
        _this.pageResourceApiService = pageResourceApiService;
        _this._user = _user;
        _this.projectTelemetry = projectTelemetry;
        _this.rootDataStore = rootDataStore;
        _this.genericHost = genericHost;
        _this._lockedBlocks = new Set();
        _this.firedNameMetric = false;
        _this.updateName = function (newName) {
            if (_this._projectData.name === newName) {
                return;
            }
            _this._projectData.name = newName;
            _this.projectApiService.saveProjectWithDebounce(_this._projectData._id, { name: newName });
            if (!_this.projectTelemetry) {
                return;
            }
            if (!_this.firedNameMetric && _this.projectHadPristineName) {
                _this.firedNameMetric = true;
                _this.projectTelemetry.projectRenamed();
            }
            _this.projectTelemetry.projectEdited(_this._projectData);
        };
        _this.updateLinkPreview = function (targetProperty, value) {
            if (_this._projectData.customLinkPreview[targetProperty] !== value) {
                _this._projectData.customLinkPreview[targetProperty] = value;
                var newLinkPreview = _this._projectData.customLinkPreview;
                _this.projectApiService.saveProjectWithDebounce(_this._projectData._id, {
                    customLinkPreview: __assign({}, newLinkPreview),
                });
                if (_this.projectTelemetry)
                    _this.projectTelemetry.projectEdited(_this._projectData);
                return newLinkPreview;
            }
        };
        _this.resetCollaboratorPageUrl = function () { return __awaiter(_this, void 0, Promise, function () {
            var newCollaboratorHash;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._projectCollaborator.resetCollaboratorHash(this._projectData)];
                    case 1:
                        newCollaboratorHash = _a.sent();
                        (0, mobx_1.runInAction)(function () { return (_this._projectData.links[0].collaboratorHash = newCollaboratorHash); });
                        return [2];
                }
            });
        }); };
        _this.getCollaboratorPageUrl = function (opts) {
            var url = _this._projectCollaborator.getCollaboratorPageUrl(_this._projectData);
            var query = opts && opts.source ? "?source=".concat(opts.source) : "";
            return "".concat(url).concat(query);
        };
        _this.getCollaboratorPageUrlWithGeneration = function (opts) { return __awaiter(_this, void 0, Promise, function () {
            var url, query;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._projectCollaborator.getCollaboratorPageUrlWithGeneration(this._projectData)];
                    case 1:
                        url = _a.sent();
                        query = opts && opts.source ? "?source=".concat(opts.source) : "";
                        return [2, "".concat(url).concat(query)];
                }
            });
        }); };
        _this.onAngularUpdated = function (angularProject) {
            return;
        };
        _this._projectData = projectData;
        _this.projectHadPristineName =
            _this._projectData.name === "Untitled" || _this._projectData.name.toLowerCase().indexOf("cloned from:") === 0;
        _this._linkStore = new ProjectLinkStore_1.ProjectLinkStore(_this._projectData._id, _this._projectData.links[0], projectApiService, projectTelemetry);
        _this._projectCollaborator = new Collaborator_1.default(projectApiService, genericHost);
        _this.pageStateHistory = [];
        return _this;
    }
    Object.defineProperty(ProjectStore.prototype, "type", {
        get: function () {
            return "ProjectStore";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "isEditable", {
        get: function () {
            var hasEditFromFolder = false;
            if (this._projectData.parentFolder) {
                hasEditFromFolder = true;
            }
            var pagePermissionDataStore = this.rootDataStore
                .getPermissionsDataStore()
                .getPagePermissions(this._projectData._id);
            var hasDirectEditPermission = !!pagePermissionDataStore.hasEditPermission(this._user._id);
            return hasDirectEditPermission || hasEditFromFolder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "_id", {
        get: function () {
            return this._projectData._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "name", {
        get: function () {
            return this._projectData.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "user", {
        get: function () {
            return this._projectData.user;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "owner", {
        get: function () {
            var _this = this;
            var pagePermissionDataStore = this.rootDataStore
                .getPermissionsDataStore()
                .getPagePermissions(this._projectData._id);
            var pageOwner = pagePermissionDataStore.permittedUsers
                .filter(PermissionTypes_1.isExistingUser)
                .find(function (permittedUser) { return permittedUser.id === _this.user; });
            if (pageOwner) {
                return { firstName: pageOwner.firstName, lastName: pageOwner.lastName, email: pageOwner.email };
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "isArchived", {
        get: function () {
            return this.tags.includes(ProjectTypes_1.SpecialProjectTag.Archived);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "isStarred", {
        get: function () {
            return this.tags.includes(ProjectTypes_1.SpecialProjectTag.Starred);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "isTemplate", {
        get: function () {
            return this.tags.includes(ProjectTypes_1.SpecialProjectTag.Template);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "isCrmTemplate", {
        get: function () {
            var _a;
            return this.isTemplate && ((_a = this.crmInfo) === null || _a === void 0 ? void 0 : _a.connected);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "templateParent", {
        get: function () {
            return this._projectData.templateParent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "parentFolder", {
        get: function () {
            return this._projectData.parentFolder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "totalLinkViews", {
        get: function () {
            return this._projectData.links.reduce(function (curr, link) {
                return curr + link.receipt.numberOfVisits;
            }, 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "usingNewEditor", {
        get: function () {
            return this._projectData.usingNewEditor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "userAction", {
        get: function () {
            return this._projectData.$userAction;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "shared", {
        get: function () {
            return this.user !== this._user._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "isAccepted", {
        get: function () {
            return this._projectData.status === Types_1.ProjectStatus.Accepted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "publishedTimestamp", {
        get: function () {
            return this._projectData.publishedAt || new Date(this._projectData.createdAt);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "createdAt", {
        get: function () {
            return this._projectData.createdAt;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "status", {
        get: function () {
            return this._projectData.status;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "subStatus", {
        get: function () {
            return this._projectData.subStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "tags", {
        get: function () {
            return lodash_1.default.uniq(this._projectData.tags);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "crmInfo", {
        get: function () {
            return this._projectData.crmInfo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "settings", {
        get: function () {
            return this._projectData.settings;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "links", {
        get: function () {
            return this._projectData.links;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "linkStore", {
        get: function () {
            return this._linkStore;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "hasAcceptEnabled", {
        get: function () {
            return this._projectData.hasAcceptEnabled || false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "hasTemplateChildren", {
        get: function () {
            return this._projectData.hasTemplateChildren || false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "partialAcceptanceData", {
        get: function () {
            return this._projectData.partialAcceptanceData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "quoteBlockCount", {
        get: function () {
            return this._projectData.quoteBlockCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "isBlueprint", {
        get: function () {
            return this._projectData.hasTemplateChildren;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "allowIndexing", {
        get: function () {
            return this._projectData.allowIndexing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "enableSocialBadge", {
        get: function () {
            return this._projectData.enableSocialBadge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "customLinkPreview", {
        get: function () {
            return this._projectData.customLinkPreview;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "manualPageValue", {
        get: function () {
            return this._projectData.manualPageValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "cachedPageValue", {
        get: function () {
            return this._projectData.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "currencyLocale", {
        get: function () {
            return this._projectData.currencyLocale;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "engagement", {
        get: function () {
            return this._projectData.engagement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "lastEditedAt", {
        get: function () {
            if (!this._projectData.lastEditedAt) {
                return "";
            }
            return new Date(this._projectData.lastEditedAt).toLocaleString(undefined, {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "lastViewedAt", {
        get: function () {
            if (!this._projectData.lastViewedAt) {
                return "";
            }
            return new Date(this._projectData.lastViewedAt).toLocaleString(undefined, {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "isWithinTimeLimit", {
        get: function () {
            var link = this._projectData.links[0];
            var timeLimit = link.timeLimit;
            if (!timeLimit) {
                return true;
            }
            var from = timeLimit.from, until = timeLimit.until, forever = timeLimit.forever;
            if (forever) {
                return true;
            }
            if (from && new Date(from) > new Date()) {
                return false;
            }
            if (until && new Date(until) < new Date()) {
                return false;
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectStore.prototype, "isWithinViewLimit", {
        get: function () {
            var link = this._projectData.links[0];
            var viewLimit = link.viewLimit, receipt = link.receipt;
            if (!viewLimit) {
                return true;
            }
            var limit = viewLimit.limit, enabled = viewLimit.enabled;
            var numberOfVisits = receipt.numberOfVisits;
            if (!enabled) {
                return true;
            }
            if (!limit || !lodash_1.default.isNumber(limit)) {
                return true;
            }
            if (limit == 0) {
                return false;
            }
            if (!numberOfVisits) {
                return true;
            }
            return numberOfVisits < limit;
        },
        enumerable: false,
        configurable: true
    });
    ProjectStore.prototype.star = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.addTag(ProjectTypes_1.SpecialProjectTag.Starred)];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    ProjectStore.prototype.archive = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.addToLocalTagsList(ProjectTypes_1.SpecialProjectTag.Archived);
                        return [4, this.pageResourceApiService.archiveResources([
                                { id: this._projectData._id, type: ResourceTypes_1.DashboardResourceType.Page },
                            ])];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    ProjectStore.prototype.unstar = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.removeTag(ProjectTypes_1.SpecialProjectTag.Starred)];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    ProjectStore.prototype.unarchive = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a, originalFolder, parentFolder, targetFolder;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.removeFromLocalTagsList(ProjectTypes_1.SpecialProjectTag.Archived);
                        _a = this._projectData, originalFolder = _a.originalFolder, parentFolder = _a.parentFolder;
                        targetFolder = originalFolder || parentFolder || null;
                        return [4, this.pageResourceApiService.unarchiveResources(targetFolder, [
                                {
                                    id: this._projectData._id,
                                    type: ResourceTypes_1.DashboardResourceType.Page,
                                },
                            ])];
                    case 1: return [2, _b.sent()];
                }
            });
        });
    };
    ProjectStore.prototype.moveToFolder = function (folderId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.projectApiService.setProjectFolder(this._projectData._id, folderId)];
                    case 1:
                        _a.sent();
                        this._projectData.parentFolder = folderId;
                        return [2];
                }
            });
        });
    };
    ProjectStore.prototype.toggleStarred = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.toggleTag(ProjectTypes_1.SpecialProjectTag.Starred)];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    ProjectStore.prototype.addLockedBlock = function (blockId) {
        this._lockedBlocks.add(blockId);
    };
    ProjectStore.prototype.removeLockedBlock = function (blockId) {
        this._lockedBlocks.delete(blockId);
    };
    ProjectStore.prototype.clearAllLockedBlocks = function () {
        this._lockedBlocks.clear();
    };
    ProjectStore.prototype.isBlockLocked = function (blockId) {
        var _this = this;
        return (0, mobx_1.computed)(function () {
            return _this._lockedBlocks.has(blockId);
        }).get();
    };
    ProjectStore.prototype.setManualPageValue = function (manualPageValue) {
        this._projectData.manualPageValue = manualPageValue;
        this.projectApiService.saveProjectWithDebounce(this._projectData._id, { manualPageValue: manualPageValue });
    };
    ProjectStore.prototype.toggleDraftLive = function () {
        if (this._projectData.status !== Types_1.ProjectStatus.Draft && this._projectData.status !== Types_1.ProjectStatus.Live) {
            throw new Error("Tried to toggle draft/live without being in one of those statuses");
        }
        var newStatus;
        if (this._projectData.status === Types_1.ProjectStatus.Draft) {
            newStatus = Types_1.ProjectStatus.Live;
        }
        else {
            newStatus = Types_1.ProjectStatus.Draft;
        }
        this.setStatus({ status: newStatus });
    };
    ProjectStore.prototype.setStatus = function (pageStatusState) {
        return __awaiter(this, void 0, Promise, function () {
            var oldStatus, oldSubStatus, newStatus, newSubStatus, autoLinkExpiry_1, newAutoExpireLink_1, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        oldStatus = this._projectData.status;
                        oldSubStatus = this._projectData.subStatus;
                        newStatus = pageStatusState.status;
                        newSubStatus = pageStatusState.subStatus;
                        this._projectData.status = newStatus;
                        this._projectData.subStatus = newSubStatus;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.projectApiService.setStatus(this._projectData._id, pageStatusState)];
                    case 2:
                        _a.sent();
                        autoLinkExpiry_1 = this._projectData.links[0].autoLinkExpiry;
                        newAutoExpireLink_1 = (0, AutoLinkExpiry_1.getAutoLinkExpiryChanges)(oldStatus, newStatus, autoLinkExpiry_1);
                        if (newAutoExpireLink_1) {
                            (0, mobx_1.runInAction)(function () {
                                _this._projectData.links[0].autoLinkExpiry = __assign(__assign({}, autoLinkExpiry_1), newAutoExpireLink_1);
                            });
                        }
                        return [3, 4];
                    case 3:
                        err_1 = _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            _this._projectData.status = oldStatus;
                            _this._projectData.subStatus = oldSubStatus;
                        });
                        return [2, Promise.reject(err_1)];
                    case 4: return [2];
                }
            });
        });
    };
    ProjectStore.prototype.setCrmInfo = function (info) {
        this._projectData.crmInfo = info;
        return this.projectApiService.saveCrmInfo(this._projectData._id, info);
    };
    ProjectStore.prototype.setDirectionality = function (languageDirection) {
        if (!this._projectData.settings) {
            this._projectData.settings = {};
        }
        if (!this._projectData.settings.localisation) {
            this._projectData.settings.localisation = {
                direction: languageDirection,
            };
        }
        else {
            this._projectData.settings.localisation.direction = languageDirection;
        }
        this.projectApiService.saveProject(this._projectData._id, { settings: this._projectData.settings });
    };
    ProjectStore.prototype.setNavigationSettings = function (navigationSettings) {
        this._projectData.settings.navigation = lodash_1.default.extend(this._projectData.settings.navigation, navigationSettings);
        this.projectApiService.saveProject(this._projectData._id, { settings: this._projectData.settings });
    };
    ProjectStore.prototype.setSpringboardSettings = function (springboardSettings) {
        var _a, _b;
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this._projectData.settings) {
                            this._projectData.settings = {};
                        }
                        if (!this._projectData.settings.springboard) {
                            this._projectData.settings.springboard = {
                                engagementMenuEnabled: (_a = springboardSettings.engagementMenuEnabled) !== null && _a !== void 0 ? _a : true,
                                contactPageOwnerEnabled: (_b = springboardSettings.engagementMenuEnabled) !== null && _b !== void 0 ? _b : true,
                            };
                        }
                        else {
                            this._projectData.settings.springboard = lodash_1.default.extend(this._projectData.settings.springboard, springboardSettings);
                        }
                        return [4, this.projectApiService.saveProject(this._projectData._id, { settings: this._projectData.settings })];
                    case 1:
                        _c.sent();
                        return [2];
                }
            });
        });
    };
    ProjectStore.prototype.setAllowIndexing = function (allowIndexing) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._projectData.allowIndexing = allowIndexing;
                        return [4, this.projectApiService.saveProject(this._projectData._id, { allowIndexing: this._projectData.allowIndexing })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    ProjectStore.prototype.setEnableSocialBadge = function (enableSocialBadge) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._projectData.enableSocialBadge = enableSocialBadge;
                        return [4, this.projectApiService.saveProject(this._projectData._id, {
                                enableSocialBadge: this._projectData.enableSocialBadge,
                            })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    ProjectStore.prototype.setHasAcceptEnabled = function (enabled) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._projectData.hasAcceptEnabled = enabled;
                        return [4, this.projectApiService.saveProject(this._projectData._id, { hasAcceptEnabled: enabled })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    ProjectStore.prototype.updateManualPageValueCurrency = function (newCurrency) {
        if (!this.manualPageValue.enabled)
            return;
        this._projectData.manualPageValue.currency = newCurrency;
    };
    ProjectStore.prototype.updateCurrencyLocale = function (newLocale) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._projectData.currencyLocale = newLocale;
                        return [4, this.projectApiService.saveProject(this._projectData._id, { currencyLocale: newLocale })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    ProjectStore.prototype.incrementQuoteBlockCount = function () {
        this._projectData.quoteBlockCount++;
    };
    ProjectStore.prototype.decrementQuoteBlockCount = function () {
        this._projectData.quoteBlockCount--;
    };
    ProjectStore.prototype.changeOwner = function (newOwnerId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                if (this.user === newOwnerId) {
                    return [2];
                }
                this._projectData.user = newOwnerId;
                return [2, this.projectApiService.changeOwner(this._projectData._id, this.user, newOwnerId)];
            });
        });
    };
    ProjectStore.prototype.addTag = function (tag) {
        return __awaiter(this, void 0, Promise, function () {
            var oldTags, addedLocally, err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        oldTags = lodash_1.default.clone(this.tags);
                        addedLocally = this.addToLocalTagsList(tag);
                        if (!addedLocally) {
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.projectApiService.addProjectTag(this._projectData._id, tag)];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        err_2 = _a.sent();
                        (0, mobx_1.runInAction)(function () { return (_this._projectData.tags = oldTags); });
                        return [2, Promise.reject(err_2)];
                    case 4: return [2];
                }
            });
        });
    };
    ProjectStore.prototype.removeTag = function (tag) {
        return __awaiter(this, void 0, Promise, function () {
            var oldTags, removedLocally, err_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        oldTags = lodash_1.default.clone(this.tags);
                        removedLocally = this.removeFromLocalTagsList(tag);
                        if (!removedLocally) {
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.projectApiService.removeProjectTag(this._projectData._id, tag)];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        err_3 = _a.sent();
                        (0, mobx_1.runInAction)(function () { return (_this._projectData.tags = oldTags); });
                        return [2, Promise.reject(err_3)];
                    case 4: return [2];
                }
            });
        });
    };
    ProjectStore.prototype.addToLocalTagsList = function (tag) {
        if (this.tags.includes(tag)) {
            return false;
        }
        var tags = __spreadArray(__spreadArray([], __read(this.tags), false), [tag], false);
        this._projectData.tags = tags;
        return true;
    };
    ProjectStore.prototype.removeFromLocalTagsList = function (tag) {
        if (!this.tags.includes(tag)) {
            return false;
        }
        var tags = lodash_1.default.difference(this.tags, [tag]);
        this._projectData.tags = tags;
        return true;
    };
    ProjectStore.prototype.toggleTag = function (tag) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                if (this.tags.includes(tag)) {
                    return [2, this.removeTag(tag)];
                }
                else {
                    return [2, this.addTag(tag)];
                }
                return [2];
            });
        });
    };
    ProjectStore.prototype.disableLinkSecurity = function () {
        return __awaiter(this, void 0, Promise, function () {
            var previousLinks, noChangedData, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        previousLinks = (0, mobx_1.toJS)(this.links);
                        this._projectData.links.forEach(function (link) {
                            if (link.isPasswordProtected) {
                                link.isPasswordProtected = false;
                            }
                            if (link.identityMapping) {
                                link.identityMapping.limitDomains.enabled = false;
                                link.identityMapping.emailVerificationEnabled = false;
                            }
                            if (link.ipFilter) {
                                link.ipFilter.enabled = false;
                            }
                            if (link.timeLimit) {
                                link.timeLimit.forever = true;
                            }
                            if (link.viewLimit) {
                                link.viewLimit.enabled = false;
                            }
                        });
                        noChangedData = lodash_1.default.isEqual(this._projectData.links, previousLinks);
                        if (noChangedData) {
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.projectApiService.saveProject(this._id, { links: (0, mobx_1.toJS)(this.links) })];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        e_1 = _a.sent();
                        this._projectData.links = previousLinks;
                        throw e_1;
                    case 4: return [2];
                }
            });
        });
    };
    ProjectStore.prototype.updateLink = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.projectApiService.saveProjectLink(this._id, this._projectData.links[0])];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    ProjectStore.prototype.updateLinkPassword = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.projectApiService.saveProjectLinkPassword(this._id, this._projectData.links[0])];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    Object.defineProperty(ProjectStore.prototype, "timeSinceCreationInHours", {
        get: function () {
            return (0, TimeSince_1.getTimeSinceInHours)(new Date(this._projectData.createdAt));
        },
        enumerable: false,
        configurable: true
    });
    ProjectStore.prototype.getPageStateHistory = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.pageStateHistory) return [3, 2];
                        _a = this;
                        return [4, this.projectApiService.getPageStateHistory(this._id)];
                    case 1:
                        _a.pageStateHistory = _b.sent();
                        _b.label = 2;
                    case 2: return [2, this.pageStateHistory];
                }
            });
        });
    };
    ProjectStore.prototype.getLockedDate = function () {
        var _a;
        return __awaiter(this, void 0, Promise, function () {
            var pageStateHistory, lastLockedState;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(0, Types_1.isPageLocked)(this.status)) {
                            throw new Error("Cannot call getLockedDate() when page is not locked (".concat(this.status, ")"));
                        }
                        return [4, this.getPageStateHistory()];
                    case 1:
                        pageStateHistory = _b.sent();
                        if (pageStateHistory.length > 0) {
                            lastLockedState = pageStateHistory.find(function (p) { return p.state.status === _this.status; });
                            return [2, lastLockedState.createdAt];
                        }
                        return [2, (_a = this._projectData.acceptanceData) === null || _a === void 0 ? void 0 : _a.backupCreatedAt];
                }
            });
        });
    };
    ProjectStore.prototype.getHash = function () {
        return this._projectData.links[0].secret;
    };
    Object.defineProperty(ProjectStore.prototype, "dataForAngular", {
        get: function () {
            return { hasAcceptEnabled: this.hasAcceptEnabled, quoteBlockCount: this.quoteBlockCount };
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_a = typeof ProjectTypes_1.IProject !== "undefined" && ProjectTypes_1.IProject) === "function" ? _a : Object)
    ], ProjectStore.prototype, "_projectData", void 0);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_b = typeof Set !== "undefined" && Set) === "function" ? _b : Object)
    ], ProjectStore.prototype, "_lockedBlocks", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "_id", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "name", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "user", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "owner", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "isArchived", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "isStarred", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "isTemplate", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "isCrmTemplate", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "templateParent", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "parentFolder", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "totalLinkViews", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "usingNewEditor", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "userAction", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "shared", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "isAccepted", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "publishedTimestamp", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_d = typeof Types_1.ProjectStatus !== "undefined" && Types_1.ProjectStatus) === "function" ? _d : Object),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "status", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_e = typeof Types_1.ProjectSubStatus !== "undefined" && Types_1.ProjectSubStatus) === "function" ? _e : Object),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "subStatus", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "tags", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_f = typeof Types_1.ProjectCrmInfo !== "undefined" && Types_1.ProjectCrmInfo) === "function" ? _f : Object),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "crmInfo", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_g = typeof ProjectTypes_1.IProjectSettings !== "undefined" && ProjectTypes_1.IProjectSettings) === "function" ? _g : Object),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "settings", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "links", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "hasTemplateChildren", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_h = typeof ProjectTypes_1.IPartialAcceptanceData !== "undefined" && ProjectTypes_1.IPartialAcceptanceData) === "function" ? _h : Object),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "partialAcceptanceData", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "quoteBlockCount", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "isBlueprint", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "allowIndexing", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "enableSocialBadge", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_j = typeof ProjectTypes_1.IProjectLinkPreview !== "undefined" && ProjectTypes_1.IProjectLinkPreview) === "function" ? _j : Object),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "customLinkPreview", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "isWithinTimeLimit", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectStore.prototype, "isWithinViewLimit", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
    ], ProjectStore.prototype, "star", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_l = typeof Promise !== "undefined" && Promise) === "function" ? _l : Object)
    ], ProjectStore.prototype, "archive", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_m = typeof Promise !== "undefined" && Promise) === "function" ? _m : Object)
    ], ProjectStore.prototype, "unstar", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_o = typeof Promise !== "undefined" && Promise) === "function" ? _o : Object)
    ], ProjectStore.prototype, "unarchive", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_p = typeof Promise !== "undefined" && Promise) === "function" ? _p : Object)
    ], ProjectStore.prototype, "moveToFolder", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_q = typeof Promise !== "undefined" && Promise) === "function" ? _q : Object)
    ], ProjectStore.prototype, "toggleStarred", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], ProjectStore.prototype, "addLockedBlock", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], ProjectStore.prototype, "removeLockedBlock", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ProjectStore.prototype, "clearAllLockedBlocks", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectStore.prototype, "updateName", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectStore.prototype, "updateLinkPreview", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_r = typeof Types_1.ManualPageValue !== "undefined" && Types_1.ManualPageValue) === "function" ? _r : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectStore.prototype, "setManualPageValue", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ProjectStore.prototype, "toggleDraftLive", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_s = typeof Types_1.PageStatusState !== "undefined" && Types_1.PageStatusState) === "function" ? _s : Object]),
        __metadata("design:returntype", typeof (_t = typeof Promise !== "undefined" && Promise) === "function" ? _t : Object)
    ], ProjectStore.prototype, "setStatus", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_u = typeof Types_1.ProjectCrmInfo !== "undefined" && Types_1.ProjectCrmInfo) === "function" ? _u : Object]),
        __metadata("design:returntype", typeof (_v = typeof Promise !== "undefined" && Promise) === "function" ? _v : Object)
    ], ProjectStore.prototype, "setCrmInfo", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], ProjectStore.prototype, "setDirectionality", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_w = typeof Partial !== "undefined" && Partial) === "function" ? _w : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectStore.prototype, "setNavigationSettings", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_x = typeof Partial !== "undefined" && Partial) === "function" ? _x : Object]),
        __metadata("design:returntype", typeof (_y = typeof Promise !== "undefined" && Promise) === "function" ? _y : Object)
    ], ProjectStore.prototype, "setSpringboardSettings", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", typeof (_z = typeof Promise !== "undefined" && Promise) === "function" ? _z : Object)
    ], ProjectStore.prototype, "setAllowIndexing", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", typeof (_0 = typeof Promise !== "undefined" && Promise) === "function" ? _0 : Object)
    ], ProjectStore.prototype, "setEnableSocialBadge", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", typeof (_1 = typeof Promise !== "undefined" && Promise) === "function" ? _1 : Object)
    ], ProjectStore.prototype, "setHasAcceptEnabled", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], ProjectStore.prototype, "updateManualPageValueCurrency", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_2 = typeof Promise !== "undefined" && Promise) === "function" ? _2 : Object)
    ], ProjectStore.prototype, "updateCurrencyLocale", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ProjectStore.prototype, "incrementQuoteBlockCount", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ProjectStore.prototype, "decrementQuoteBlockCount", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_3 = typeof Promise !== "undefined" && Promise) === "function" ? _3 : Object)
    ], ProjectStore.prototype, "changeOwner", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_5 = typeof Promise !== "undefined" && Promise) === "function" ? _5 : Object)
    ], ProjectStore.prototype, "addTag", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_7 = typeof Promise !== "undefined" && Promise) === "function" ? _7 : Object)
    ], ProjectStore.prototype, "removeTag", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Boolean)
    ], ProjectStore.prototype, "addToLocalTagsList", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Boolean)
    ], ProjectStore.prototype, "removeFromLocalTagsList", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_11 = typeof Promise !== "undefined" && Promise) === "function" ? _11 : Object)
    ], ProjectStore.prototype, "toggleTag", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_12 = typeof Promise !== "undefined" && Promise) === "function" ? _12 : Object)
    ], ProjectStore.prototype, "disableLinkSecurity", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_13 = typeof Promise !== "undefined" && Promise) === "function" ? _13 : Object)
    ], ProjectStore.prototype, "updateLink", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_14 = typeof Promise !== "undefined" && Promise) === "function" ? _14 : Object)
    ], ProjectStore.prototype, "updateLinkPassword", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectStore.prototype, "onAngularUpdated", void 0);
    return ProjectStore;
}(AngularSyncStore_1.default));
exports.default = ProjectStore;
function extractDataFromAngular(projectData) {
    return lodash_1.default.pick(projectData, "hasAcceptEnabled", "quoteBlockCount");
}
